import { useEffect, useRef, useState } from "react";
import { copy, toast } from "../lib/util";

const COPIED = "Linket er kopieret";

async function nativeShare(title, url) {
  if (!navigator.share) return false;
  try { await navigator.share({ title, url }); } catch (e) {}
  return true;
}

// Recipe "Del": native share sheet, else a menu with "Del på Facebook" and "Kopiér link".
export function ShareMenu({ url, title, testid = "share" }) {
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  useEffect(() => {
    if (!open) return;
    const h = e => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    const k = e => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("click", h); document.addEventListener("keydown", k);
    return () => { document.removeEventListener("click", h); document.removeEventListener("keydown", k); };
  }, [open]);
  const click = async () => { if (!(await nativeShare(title, url))) setOpen(o => !o); };
  const doCopy = async () => { await copy(url); toast(COPIED); setOpen(false); };
  return (
    <div className="shr" ref={box}>
      <button className="btn ghost" type="button" id="share" aria-expanded={String(open)} aria-haspopup="menu" onClick={click} data-testid={`${testid}-button`}>Del</button>
      {open && (
        <div className="shr-menu" role="menu" data-testid={`${testid}-menu`}>
          <a role="menuitem" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer"
            onClick={() => setOpen(false)} data-testid={`${testid}-facebook`}><span className="shr-fb" aria-hidden="true">f</span>Del på Facebook</a>
          <button role="menuitem" type="button" onClick={doCopy} data-testid={`${testid}-copy`}><span className="shr-ic" aria-hidden="true">🔗</span>Kopiér link</button>
        </div>
      )}
    </div>
  );
}

// Køleskabet "Del forslag": native share sheet, else copy with toast.
export function ShareLink({ url, title, label, testid }) {
  const click = async () => { if (!(await nativeShare(title, url))) { await copy(url); toast(COPIED); } };
  return <button className="btn ghost" type="button" onClick={click} data-testid={testid}>{label}</button>;
}
